import BaseApi from '~/api/base';
class ProjectWorkspaceDocuments extends BaseApi {
    constructor() {
        super('/projects-workspace/documents');
    }
}
const ProjectWorkspaceDocumentsApi = new ProjectWorkspaceDocuments();
export default ProjectWorkspaceDocumentsApi;
